import React from 'react';

const About = () => {
  const team = [
    { name: 'Dr. Ferdinard Adungo', role: 'Lead Epidemiologist, Principal Research Scientist at KEMRI', image: '/images/team-member1.jpg' },
    { name: 'Benard Oluoch', role: 'Health Informatics Specialist, MSc in Health Informatics', image: '/images/team-member2.jpg' },
    { name: 'Charles Ragot', role: 'Entomologist and Laboratory Technician at KEMRI', image: '/images/team-member3.jpg' },
    { name: 'Jane Ikapesi', role: 'Social Scientist at KEMRI, Director at Ecowellness Alliance CBO', image: '/images/team-member4.jpg' },
    { name: 'Caroline Ndege', role: 'Molecular Biologist, PhD Student at Maseno University, Researcher at JICA SATREPS', image: '/images/team-member5.jpg' },
    { name: 'Aziza Obuya', role: 'Biostatistician and Computer Scientist at KEMRI', image: '/images/team-member6.jpg' },
  ];

  const partners = ['/images/partner-logo2.png', '/images/partner-logo1.png']; // Update with real

  return (
    <section id="about" className="py-20 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-blue-800">About Us</h2>
        <p className="text-center text-gray-600 max-w-2xl mx-auto mb-12 text-lg">
          A collective of technologists, epidemiologists, entomologists, social scientists, molecular biologists, biostatisticians, and computer scientists advancing digital health in Kenya and beyond through platforms, publications, and activities.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {team.map((member, index) => (
            <div key={index} className="text-center p-4 bg-white rounded-xl shadow-md">
              <img src={member.image} alt={member.name} className="w-32 h-32 rounded-full mx-auto mb-4 object-cover" />
              <h3 className="text-xl font-semibold text-teal-600">{member.name}</h3>
              <p className="text-gray-600">{member.role}</p>
            </div>
          ))}
        </div>
        <div className="text-center">
          <h3 className="text-2xl font-semibold mb-6 text-blue-800">Our Partners</h3>
          <div className="flex justify-center space-x-8">
            {partners.map((logo, index) => (
              <img key={index} src={logo} alt={`Partner ${index + 1}`} className="h-16 object-contain" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;